import api from "@/services/api";

const { put } = api.getPrefixedMethods("assignments");

const TARGET_KEYS = {
  submission: "orderKey",
  document: "intakeDocumentKey",
  order: "intakeOrderId",
};

export const assignmentsService = {
  setAssignees(entityType, entityId, userIds) {
    return put("", { [TARGET_KEYS[entityType]]: entityId, userIds });
  },
};
